import { formatActivityTime } from '../lib/format.js';

// Manager-view "Team activity". CJ 2026-07-30: chat is deprecated, so the
// "last opened chat" + "unread chats" rows are gone — last login is the only
// meaningful signal left here.
export function ActivityRows({ activity }) {
  const login = formatActivityTime(activity?.last_login_at);
  const rowStyle = { display: 'grid', gridTemplateColumns: '160px 1fr', gap: 12, padding: '8px 0', fontSize: 13 };
  const labelStyle = { color: '#757575', fontWeight: 600 };
  return (
    <div>
      <div style={rowStyle}>
        <div style={labelStyle}>Last login</div>
        <div style={{ color: login.stale ? '#b00020' : '#212121' }}>
          {login.rel} <span style={{ color: '#9e9e9e', fontSize: 12 }}>· {login.abs}</span>
        </div>
      </div>
    </div>
  );
}
